import {SelectOptionType} from "../../types/admin/selectOptionType";

// eslint-disable-next-line no-shadow
export enum MenuMaterialType {
  URL = 1,
  MOVIE = 2,
  PDF = 3,
  IMAGE = 4,
  OTHER = 5
}

export const getMenuMaterialTypeText = (menuMaterialType: MenuMaterialType): string => {
  let text: string = '';

  switch (menuMaterialType) {
    case MenuMaterialType.URL:
      text = 'URL';
      break;
    case MenuMaterialType.MOVIE:
      text = '動画';
      break;
    case MenuMaterialType.PDF:
      text = 'PDF';
      break;
    case MenuMaterialType.IMAGE:
      text = '画像';
      break;
    case MenuMaterialType.OTHER:
      text = 'その他ファイル';
      break;
    default:
      // ToDo: Errorクラス、エラーメッセージをもっと適当なものに
      throw new Error(`想定していないMenuType（${menuMaterialType}）が渡されました。`);
  }

  return text;
};

export const getMenuMaterialTypeSelectOptions = (): SelectOptionType[] => {
  return (Object.keys(MenuMaterialType) as Array<keyof typeof MenuMaterialType>)
    .map(key => parseInt(key, 10))
    .filter( key => !Number.isNaN(key))
    .map((key: number) => {
      const selectOption: SelectOptionType = {
        value: key,
        label: getMenuMaterialTypeText(key),
      }
      return selectOption;
    });
}